import { useLocale } from "next-intl";
import { createNavigation } from "next-intl/navigation";
import { defineRouting, type Pathnames } from "next-intl/routing";
import { getLocale } from "next-intl/server";
import type { ComponentProps } from "react";
import { defaultLocale } from "@/i18n/defaults";

export const locales = ["pl", "cz"] as const;

export const localeNames = {
  pl: "Polski",
  cz: "Čeština",
  en: "English",
};

export const pathnames = {
  // NOTE: The pathnames work, but need to update navigation system to use them. Will be done in the next PR.

  // (public)
  "/": "/",

  "/blog": "/blog",
  "/blog/[slug]": "/blog/[slug]",

  "/diets": {
    pl: "/diety-pudelkowe",
    cz: "/diety-krabickove",
    // en: '/diets',
  },

  "/diets/[[...slug]]": {
    pl: "/diety-pudelkowe/[[...slug]]",
    cz: "/diety-krabickove/[[...slug]]",
    // en: '/diets/[[...slug]]',
  },

  "/diets/[slug]": {
    pl: "/diety-pudelkowe/[slug]",
    cz: "/diety-krabickove/[slug]",
    // en: '/offer/[slug]',
  },

  "/caterings/[slug]": {
    pl: "/catering-dietetyczny/[slug]",
    cz: "/catering-dietni/[slug]",
    // en: '/caterings/[slug]',
  },

  "/caterings/[[...slug]]": {
    pl: "/cateringi-dietetyczne/[[...slug]]",
    cz: "/cateringy-dietni/[[...slug]]",
    // en: '/caterings/[[...slug]]',
  },

  "/configure-diet/[slug]": {
    pl: "/konfiguracja-diety/[slug]",
    cz: "/konfigurace-diety/[slug]",
    // en: '/configure-diet/[slug]',
  },

  "/cart": {
    pl: "/koszyk",
    cz: "/kosik",
    // en: '/cart',
  },

  "/cart/[id]": {
    pl: "/edycja-diety/[id]",
    cz: "/uprava-diety/[id]",
    // en: '/cart/[id]',
  },

  "/checkout": {
    pl: "/zamowienie",
    cz: "/objednavka",
    // en: '/checkout',
  },

  "/checkout/status/[id]": {
    pl: "/zamowienie/status/[id]",
    cz: "/objednavka/status/[id]",
    // en: '/checkout/status/[id]',
  },

  "/checkout/summary/[id]": {
    pl: "/zamowienie/podsumowanie/[id]",
    cz: "/objednavka/shrnuti/[id]",
    // en: '/checkout/summary/[id]',
  },

  "/privacy-policy": {
    pl: "/polityka-prywatnosci",
    cz: "/ochrana-osobnich-udaju",
    // en: '/privacy-policy',
  },

  "/help-center": {
    pl: "/centrum-pomocy",
    cz: "/centrum-napovedy",
    // en: '/help-center',
  },

  "/regulations": {
    pl: "/regulamin",
    cz: "/obchodni-podminky",
    // en: '/regulations',
  },
  "/account-deleted": {
    pl: "/usuniete-konto",
    cz: "/smazany-ucet",
    // en: '/account-deleted',
  },

  "/supplier-regulations": {
    pl: "/regulamin-dostawcy",
    cz: "/obchodni-podminky-dodavatele",
    // en: '/supplier-regulations',
  },

  // (protected)
  "/panel": {
    pl: "/konto",
    cz: "/ucet",
    // en: '/panel',
  },
  "/panel/orders": {
    pl: "/konto/zamowienia",
    cz: "/ucet/objednavky",
    // en: '/panel/orders',
  },
  "/panel/my-addresses": {
    pl: "/konto/moje-adresy",
    cz: "/ucet/moje-adresy",
    // en: '/panel/my-addresses',
  },
  "/panel/discounts": {
    pl: "/konto/moje-kupony",
    cz: "/ucet/slevove-kupony",
    // en: '/panel/my-discounts',
  },
  "/panel/diets": {
    pl: "/konto/moje-diety",
    cz: "/ucet/moje-diety",
    // en: '/panel/diets',
  },
  "/panel/my-account": {
    pl: "/konto/moje-konto",
    cz: "/ucet/muj-ucet",
    // en: '/panel/my-account',
  },
  "/panel/help-center": {
    pl: "/konto/centrum-pomocy",
    cz: "/ucet/centrum-napovedy",
    // en: '/panel/help-center',
  },
  "/panel/diets/[id]": {
    pl: "/konto/moje-diety/[id]",
    cz: "/ucet/moje-diety/[id]",
    // en: '/panel/diets/[id]',
  },
  "/reorder/[id]": {
    pl: "/zamow-ponownie/[id]",
    cz: "/objednat-znovu/[id]",
    // en: '/reorder/[id]',
  },
  // (auth)
  "/sign-in/[[...sign-in]]": {
    pl: "/logowanie/[[...sign-in]]",
    cz: "/prihlaseni/[[...sign-in]]",
    // en: '/sign-in/[[...sign-in]]',
  },

  "/sign-up/[[...sign-up]]": {
    pl: "/rejestracja/[[...sign-up]]",
    cz: "/registrace/[[...sign-up]]",
    // en: '/sign-up/[[...sign-up]]',
  },
  "/multidiet-configuration": {
    pl: "/konfiguracja-multidiety",
    cz: "/konfigurace-multidiety",
    // en: '/multidiet-configuration',
  },
  "/multidiet": {
    pl: "/multidieta",
    cz: "/multidieta",
    // en: '/multidiet',
  },
  "/sentenced-he": {
    pl: "/skazany",
    cz: "/odsouzeny",
    // en: '/sentenced',
  },
  "/sentenced-she": {
    pl: "/skazana",
    cz: "/odsouzena",
    // en: '/sentenced-she',
  },
  "/burn": {
    pl: "/przesiadka",
    cz: "/transfer",
    // en: '/transfer',
  },
  "/new-user-discount": {
    pl: "/rabat-dla-nowego",
    cz: "/rabat-dla-noweho",
    // en: '/transfer',
  },
  "/[slug]": {
    pl: "/[slug]",
    cz: "/[slug]",
    // en: '/[slug]',
  },
  "/[slug]/[article]": {
    pl: "/[slug]/[article]",
    cz: "/[slug]/[article]",
    // en: '/[slug]/[article]',
  },
  "/[slug]/diets": {
    pl: "/[slug]/diety",
    cz: "/[slug]/diety",
    // en: '/[slug]/diets',
  },

  "/authors": {
    pl: "/autorzy",
    cz: "/autori",
    // en: '/authors',
  },

  "/authors/[slug]": {
    pl: "/autorzy/[slug]",
    cz: "/autori/[slug]",
    // en: '/authors/[slug]',
  },
  "/extend/[id]": {
    pl: "/przedluzenie-diety/[id]",
    cz: "/prodlouzeni-diety/[id]",
    // en: '/extend/[id]',
  },
  "/blik": {
    pl: "/promocja-blik",
    cz: "/blik-promo",
    // en: '/blik-promotion',
  },
  "/mobile-app": {
    pl: "/aplikacja-mobilna",
    cz: "/mobilni-aplikace",
    // en: '/mobile-app',
  },

} satisfies Pathnames<typeof locales>;

export const getLocaleForPathname = () => {
  const locale = useLocale() as (typeof locales)[number];
  return locale;
};

export const getLocaleForPathnameAsync = async () => {
  const locale = (await getLocale()) as (typeof locales)[number];
  return locale;
};

export const getLangCode = async () => {
  const locale = await getLocaleForPathnameAsync();
  return locale === "cz" ? "cs" : locale;
};

export const getLangCodeForLocale = (locale: (typeof locales)[number]) => {
  return locale === "cz" ? "cs" : locale;
};

export const getAllLangCodes = () => {
  return locales.map((locale) => (locale === "cz" ? "cs" : locale));
};

export const routing = defineRouting({
  locales,
  defaultLocale: defaultLocale as (typeof locales)[number],
  localePrefix: "as-needed",
  pathnames: pathnames as typeof pathnames & Record<string & {}, string>,
  // HIDDEN language detection for now
  localeDetection: false,
});

const {
  Link,
  redirect,
  usePathname,
  useRouter,
  getPathname: originalGetPathname,
} = createNavigation(routing);

export type LocalizedRoute = ComponentProps<typeof Link>["href"];

// Override getPathname to fix double locale issue
const getPathname = (options: {
  href: any;
  locale: string;
  preserveLocalePrefix?: boolean;
}) => {
  const pathname = originalGetPathname(options);

  let fixedPathname = pathname;

  // Handle the root path case specifically
  if (options.href === "/" || options.href === "") {
    // For root path, just return '/' - the Link component will handle the locale prefix
    return "/";
  }

  if (pathname.startsWith(`/${options.locale}/${options.locale}`)) {
    fixedPathname = pathname.replace(
      `/${options.locale}/${options.locale}`,
      `/${options.locale}`
    );
  }

  // Check if the pathname already contains the locale prefix
  if (
    pathname.startsWith(`/${options.locale}/`) &&
    !options.preserveLocalePrefix
  ) {
    // Strip the locale prefix so Link can add it properly
    fixedPathname = pathname.replace(`/${options.locale}/`, "/");
  }

  if (pathname.endsWith(`/${options.locale}`)) {
    // Strip the locale suffix so Link can add it properly
    fixedPathname = pathname.replace(`/${options.locale}`, "");
  }

  return fixedPathname;
};

export { Link, redirect, usePathname, useRouter, getPathname };
